import { render } from "./CortizoProform.vue?vue&type=template&id=3132b075&ts=true"
import script from "./CortizoProform.vue?vue&type=script&lang=ts"
export * from "./CortizoProform.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__